export const dataset = [
	{
		id: 1,
		data: [
			{
				x: "",
				y: 1,
			},
			{
				x: "51 強",
				y: 18,
			},
			{
				x: "30 強",
				y: null,
			},
			{
				x: "21 強",
				y: null,
			},
			{
				x: "18 強",
				y: null,
			},
			{
				x: "16 強",
				y: null,
			},
			{
				x: "14 強",
				y: null,
			},
			{
				x: "12 強",
				y: null,
			},
		],
	},
	{
		id: 2,
		data: [
			{
				x: "",
				y: 2,
			},
			{
				x: "51 強",
				y: 4,
			},
			{
				x: "30 強",
				y: 2,
			},
			{
				x: "21 強",
				y: 7,
			},
			{
				x: "18 強",
				y: 5,
			},
			{
				x: "16 強",
				y: 6,
			},
			{
				x: "14 強",
				y: 6,
			},
			{
				x: "12 強",
				y: 2,
			},
		],
	},
	{
		id: 3,
		data: [
			{
				x: "",
				y: 3,
			},
			{
				x: "51 強",
				y: 10,
			},
			{
				x: "30 強",
				y: 8,
			},
			{
				x: "21 強",
				y: 3,
			},
			{
				x: "18 強",
				y: 3,
			},
			{
				x: "16 強",
				y: 2,
			},
			{
				x: "14 強",
				y: 1,
			},
			{
				x: "12 強",
				y: 3,
			},
		],
	},
	{
		id: 4,
		data: [
			{
				x: "",
				y: 4,
			},
			{
				x: "51 強",
				y: 6,
			},
			{
				x: "30 強",
				y: 4,
			},
			{
				x: "21 強",
				y: 2,
			},
			{
				x: "18 強",
				y: 2,
			},
			{
				x: "16 強",
				y: 3,
			},
			{
				x: "14 強",
				y: 4,
			},
			{
				x: "12 強",
				y: 1,
			},
		],
	},
	{
		id: 5,
		data: [
			{
				x: "",
				y: 5,
			},
			{
				x: "51 強",
				y: 12,
			},
			{
				x: "30 強",
				y: 15,
			},
			{
				x: "21 強",
				y: null,
			},
			{
				x: "18 強",
				y: null,
			},
			{
				x: "16 強",
				y: null,
			},
			{
				x: "14 強",
				y: null,
			},
			{
				x: "12 強",
				y: null,
			},
		],
	},
	{
		id: 6,
		data: [
			{
				x: "",
				y: 6,
			},
			{
				x: "51 強",
				y: 8,
			},
			{
				x: "30 強",
				y: 9,
			},
			{
				x: "21 強",
				y: 8,
			},
			{
				x: "18 強",
				y: 9,
			},
			{
				x: "16 強",
				y: null,
			},
			{
				x: "14 強",
				y: null,
			},
			{
				x: "12 強",
				y: null,
			},
		],
	},
	{
		id: 7,
		data: [
			{
				x: "",
				y: 7,
			},
			{
				x: "51 強",
				y: 5,
			},
			{
				x: "30 強",
				y: 6,
			},
			{
				x: "21 強",
				y: 6,
			},
			{
				x: "18 強",
				y: 6,
			},
			{
				x: "16 強",
				y: 5,
			},
			{
				x: "14 強",
				y: 5,
			},
			{
				x: "12 強",
				y: 5,
			},
		],
	},
	{
		id: 8,
		data: [
			{
				x: "",
				y: 8,
			},
			{
				x: "51 強",
				y: 24,
			},
			{
				x: "30 強",
				y: null,
			},
			{
				x: "21 強",
				y: null,
			},
			{
				x: "18 強",
				y: null,
			},
			{
				x: "16 強",
				y: null,
			},
			{
				x: "14 強",
				y: null,
			},
			{
				x: "12 強",
				y: null,
			},
		],
	},
	{
		id: 9,
		data: [
			{
				x: "",
				y: 9,
			},
			{
				x: "51 強",
				y: 15,
			},
			{
				x: "30 強",
				y: 13,
			},
			{
				x: "21 強",
				y: null,
			},
			{
				x: "18 強",
				y: null,
			},
			{
				x: "16 強",
				y: null,
			},
			{
				x: "14 強",
				y: null,
			},
			{
				x: "12 強",
				y: null,
			},
		],
	},
	{
		id: 10,
		data: [
			{
				x: "",
				y: 10,
			},
			{
				x: "51 強",
				y: 19,
			},
			{
				x: "30 強",
				y: null,
			},
			{
				x: "21 強",
				y: null,
			},
			{
				x: "18 強",
				y: null,
			},
			{
				x: "16 強",
				y: null,
			},
			{
				x: "14 強",
				y: null,
			},
			{
				x: "12 強",
				y: null,
			},
		],
	},
	{
		id: 11,
		data: [
			{
				x: "",
				y: 11,
			},
			{
				x: "51 強",
				y: 26,
			},
			{
				x: "30 強",
				y: null,
			},
			{
				x: "21 強",
				y: null,
			},
			{
				x: "18 強",
				y: null,
			},
			{
				x: "16 強",
				y: null,
			},
			{
				x: "14 強",
				y: null,
			},
			{
				x: "12 強",
				y: null,
			},
		],
	},
	{
		id: 12,
		data: [
			{
				x: "",
				y: 12,
			},
			{
				x: "51 強",
				y: 3,
			},
			{
				x: "30 強",
				y: 1,
			},
			{
				x: "21 強",
				y: 1,
			},
			{
				x: "18 強",
				y: 1,
			},
			{
				x: "16 強",
				y: 1,
			},
			{
				x: "14 強",
				y: 3,
			},
			{
				x: "12 強",
				y: 4,
			},
		],
	},
	{
		id: 13,
		data: [
			{
				x: "",
				y: 13,
			},
			{
				x: "51 強",
				y: 22,
			},
			{
				x: "30 強",
				y: null,
			},
			{
				x: "21 強",
				y: null,
			},
			{
				x: "18 強",
				y: null,
			},
			{
				x: "16 強",
				y: null,
			},
			{
				x: "14 強",
				y: null,
			},
			{
				x: "12 強",
				y: null,
			},
		],
	},
	{
		id: 14,
		data: [
			{
				x: "",
				y: 14,
			},
			{
				x: "51 強",
				y: 9,
			},
			{
				x: "30 強",
				y: 7,
			},
			{
				x: "21 強",
				y: 9,
			},
			{
				x: "18 強",
				y: 7,
			},
			{
				x: "16 強",
				y: 8,
			},
			{
				x: "14 強",
				y: null,
			},
			{
				x: "12 強",
				y: null,
			},
		],
	},
	{
		id: 15,
		data: [
			{
				x: "",
				y: 15,
			},
			{
				x: "51 強",
				y: 13,
			},
			{
				x: "30 強",
				y: 10,
			},
			{
				x: "21 強",
				y: 10,
			},
			{
				x: "18 強",
				y: null,
			},
			{
				x: "16 強",
				y: null,
			},
			{
				x: "14 強",
				y: null,
			},
			{
				x: "12 強",
				y: null,
			},
		],
	},
	{
		id: 16,
		data: [
			{
				x: "",
				y: 16,
			},
			{
				x: "51 強",
				y: 23,
			},
			{
				x: "30 強",
				y: null,
			},
			{
				x: "21 強",
				y: null,
			},
			{
				x: "18 強",
				y: null,
			},
			{
				x: "16 強",
				y: null,
			},
			{
				x: "14 強",
				y: null,
			},
			{
				x: "12 強",
				y: null,
			},
		],
	},
	{
		id: 17,
		data: [
			{
				x: "",
				y: 17,
			},
			{
				x: "51 強",
				y: 2,
			},
			{
				x: "30 強",
				y: 3,
			},
			{
				x: "21 強",
				y: 4,
			},
			{
				x: "18 強",
				y: 4,
			},
			{
				x: "16 強",
				y: 7,
			},
			{
				x: "14 強",
				y: 3,
			},
			{
				x: "14 強",
				y: null,
			},
			{
				x: "12 強",
				y: null,
			},
		],
	},
	{
		id: 18,
		data: [
			{
				x: "",
				y: 18,
			},
			{
				x: "51 強",
				y: 17,
			},
			{
				x: "30 強",
				y: null,
			},
			{
				x: "21 強",
				y: null,
			},
			{
				x: "18 強",
				y: null,
			},
			{
				x: "16 強",
				y: null,
			},
			{
				x: "14 強",
				y: null,
			},
			{
				x: "12 強",
				y: null,
			},
		],
	},
	{
		id: 19,
		data: [
			{
				x: "",
				y: 19,
			},
			{
				x: "51 強",
				y: 21,
			},
			{
				x: "30 強",
				y: null,
			},
			{
				x: "21 強",
				y: null,
			},
			{
				x: "18 強",
				y: null,
			},
			{
				x: "16 強",
				y: null,
			},
			{
				x: "14 強",
				y: null,
			},
			{
				x: "12 強",
				y: null,
			},
		],
	},
	{
		id: 20,
		data: [
			{
				x: "",
				y: 20,
			},
			{
				x: "51 強",
				y: 11,
			},
			{
				x: "30 強",
				y: 11,
			},
			{
				x: "21 強",
				y: null,
			},
			{
				x: "18 強",
				y: null,
			},
			{
				x: "16 強",
				y: null,
			},
			{
				x: "14 強",
				y: null,
			},
			{
				x: "12 強",
				y: null,
			},
		],
	},
	{
		id: 21,
		data: [
			{
				x: "",
				y: 21,
			},
			{
				x: "51 強",
				y: 16,
			},
			{
				x: "30 強",
				y: null,
			},
			{
				x: "21 強",
				y: null,
			},
			{
				x: "18 強",
				y: null,
			},
			{
				x: "16 強",
				y: null,
			},
			{
				x: "14 強",
				y: null,
			},
			{
				x: "12 強",
				y: null,
			},
		],
	},
	{
		id: 22,
		data: [
			{
				x: "",
				y: 22,
			},
			{
				x: "51 強",
				y: 14,
			},
			{
				x: "30 強",
				y: 14,
			},
			{
				x: "21 強",
				y: null,
			},
			{
				x: "18 強",
				y: null,
			},
			{
				x: "16 強",
				y: null,
			},
			{
				x: "14 強",
				y: null,
			},
			{
				x: "12 強",
				y: null,
			},
		],
	},
	{
		id: 23,
		data: [
			{
				x: "",
				y: 23,
			},
			{
				x: "51 強",
				y: 20,
			},
			{
				x: "30 強",
				y: null,
			},
			{
				x: "21 強",
				y: null,
			},
			{
				x: "18 強",
				y: null,
			},
			{
				x: "16 強",
				y: null,
			},
			{
				x: "14 強",
				y: null,
			},
			{
				x: "12 強",
				y: null,
			},
		],
	},
	{
		id: 24,
		data: [
			{
				x: "",
				y: 24,
			},
			{
				x: "51 強",
				y: 25,
			},
			{
				x: "30 強",
				y: null,
			},
			{
				x: "21 強",
				y: null,
			},
			{
				x: "18 強",
				y: null,
			},
			{
				x: "16 強",
				y: null,
			},
			{
				x: "14 強",
				y: null,
			},
			{
				x: "12 強",
				y: null,
			},
		],
	},
	{
		id: 25,
		data: [
			{
				x: "",
				y: 25,
			},
			{
				x: "51 強",
				y: 7,
			},
			{
				x: "30 強",
				y: 12,
			},
			{
				x: "21 強",
				y: null,
			},
			{
				x: "18 強",
				y: null,
			},
			{
				x: "16 強",
				y: null,
			},
			{
				x: "14 強",
				y: null,
			},
			{
				x: "12 強",
				y: null,
			},
		],
	},
	{
		id: 26,
		data: [
			{
				x: "",
				y: 26,
			},
			{
				x: "51 強",
				y: 1,
			},
			{
				x: "30 強",
				y: 5,
			},
			{
				x: "21 強",
				y: 5,
			},
			{
				x: "18 強",
				y: 8,
			},
			{
				x: "16 強",
				y: 4,
			},
			{
				x: "14 強",
				y: 2,
			},
			{
				x: "12 強",
				y: 6,
			},
		],
	},
];
